import React, { useState } from "react";
import {
  Show,
  ShowController,
  SimpleShowLayout,
  TextField,
  NumberField,
  FunctionField,
  BooleanField,
  ReferenceField,
  Datagrid,
} from "react-admin";
import CopyButton from "../../components/CopyButton";
import Button from "@material-ui/core/Button";
import OrgContactPopup from "../../components/Organization/OrgContactPopup";
import OrgZonePopup from "../../components/Organization/OrgZonePopup";
import OrgContactListPopup from "../../components/Organization/OrgContactListPopup";
import OrgEventHistoryPopup from "../../components/Organization/OrgEventHistoryPopup";
import OrgWebhookPopup from "../../components/Organization/OrgWebhookPopup";
import OrgWebhookEventsPopup from "../../components/Organization/OrgWebhookEventsPopup";
import OrgPanelEventsPopup from "../../components/Organization/OrgPanelEventsPopup";
import OrgPanelPopup from "../../components/Organization/OrgPanelPopup";
import OrgPendantPopup from "../../components/Organization/OrgPendantsPopup";
import OrgCameraPopup from "../../components/Organization/OrgCameraPopup";
import OrgDTPopup from "../../components/Organization/OrgDTPopup";
import OrgAdminsPopup from "../../components/Organization/OrgAdminsPopup";
import useUser from "../../hooks/useUser";

const styles = {
  section: {
    border: 0,
    color: "white",
    maxHeight: 250,
    overflow: "auto",
    position: "relative",
  },
  button: {
    fontSize: "small",
    color: "white",
    background: "#9ca0a6",
    borderRadius: "10px",
    textAlign: "center",
    width: 200,
    maxHeight: 50,
    marginBottom: "25px",
  },
  createButton: {
    fontSize: "10",
    color: "#03a9f4",
    background: "#FAFAFA",
    border: "1px solid #dcdcdc",
    borderRadius: "10px",
    textAlign: "center",
  },
  mobileAppEnabledSection: {
    display: "flex",
    flexDirection: "row",
    fontFamily: "Arial",
    marginBottom: "20px",
  },
};

const GoogleMapsLink = (props) => {
  async function getCoords() {
    const latlng = `${props.record.lat},${props.record.lng}`;
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${latlng}`,
      "_blank"
    );
  }

  return (
    <Button style={{ color: "#03a9f4" }} onClick={() => getCoords()}>
      Open in Google Maps
    </Button>
  );
};

const Indicator = (props) => {
  const color = props.record[props.indicator_source] ? "#1DD317" : "red";

  return (
    <div style={{ position: "absolute", left: "calc(230px)", color: "black" }}>
      <div
        style={{
          backgroundColor: `${color}`,
          height: "10px",
          width: "10px",
          borderRadius: "50%",
          border: "1px solid gray",
        }}
      ></div>
    </div>
  );
};

const OrganizationShow = (props) => {
  const user = useUser();

  const [isZoneToggleOn, setisZoneToggleOn] = useState(false);
  const [isPendantToggleOn, setisPendantToggleOn] = useState(false);
  const [isAlertToggleOn, setisAlertToggleOn] = useState(false);
  const [isPOCToggleOn, setisPOCToggleOn] = useState(false);
  const [isUserToggleOn, setisUserToggleOn] = useState(false);
  const [isContactlistToggleOn, setisContactlistToggleOn] = useState(false);
  const [isContactToggleOn, setisContactToggleOn] = useState(false);
  const [isDispatchTabletToggleOn, setisDispatchTabletToggleOn] =
    useState(false);
  const [isMobileAppToggleOn, setisMobileAppToggleOn] = useState(false);
  const [isWebhookToggleOn, setisWebhookToggleOn] = useState(false);
  const [isWebhookEventsToggleOn, setisWebhookEventsToggleOn] = useState(false);
  const [isPanelToggleOn, setisPanelToggleOn] = useState(false);
  const [isPanelEventsToggleOn, setisPanelEventsToggleOn] = useState(false);

  const [isCameraToggleOn, setisCameraToggleOn] = useState(false);

  return (
    <ShowController {...props}>
      {(controllerProps) => (
        <Show {...props} {...controllerProps} title="Organization Details">
          <SimpleShowLayout>
            {controllerProps &&
            controllerProps.record &&
            controllerProps.record.channel_partner_owner_id ? (
              <ReferenceField
                perPage={1000000000000}
                fullWidth
                link="show"
                label="Channel Organization"
                source="channel_partner_owner_id"
                reference="organizations"
                filter={{ channel: "channel" }}
              >
                <TextField source="name" />
              </ReferenceField>
            ) : null}
            {/*always visibile*/}
            <TextField source="name" />
            <TextField
              label="Dispatch Console Alert Contact Number"
              source="alert_contact_phone_number"
            />
            <CopyButton label="Email">
              <FunctionField
                render={(record) =>
                  `${
                    window.location.origin.includes("https://app") ? "" : "test"
                  }${record.id}@alerts.sos-tech.com`
                }
              />
            </CopyButton>
            <TextField
              label="Email Notification Header"
              source="email_notification_header"
            />
            <TextField label="Notes" source="notes" />
            <FunctionField
              label="Address"
              render={(record) =>
                `${record.address_line_1}, ${
                  record.address_line_2 ? record.address_line_2 + "," : ""
                } ${record.address_city} ${record.address_state} ${
                  record.address_zip
                }`
              }
            />

            {/* If Mobile App Enabled */}
            <Button
              style={styles.button}
              onClick={() => setisMobileAppToggleOn(!isMobileAppToggleOn)}
            >
              Mobile App Status
              <Indicator
                record={controllerProps.record}
                indicator_source={"enable_mobile_app"}
              />
            </Button>
            {isMobileAppToggleOn && (
              <div style={styles.mobileAppEnabledSection}>
                Mobile App is{" "}
                {controllerProps.record &&
                controllerProps.record.enable_mobile_app
                  ? "Enabled"
                  : "Disabled"}
              </div>
            )}
            {isMobileAppToggleOn &&
              controllerProps.record &&
              controllerProps.record.enable_mobile_app && (
                <NumberField label="Latitude" source="lat" />
              )}
            {isMobileAppToggleOn &&
              controllerProps.record &&
              controllerProps.record.enable_mobile_app && (
                <NumberField label="Longitude" source="lng" />
              )}
            {isMobileAppToggleOn &&
              controllerProps.record &&
              controllerProps.record.enable_mobile_app && (
                <NumberField
                  label="Mobile App Range in Meters"
                  source="mobile_trigger_range"
                />
              )}
            {isMobileAppToggleOn &&
              controllerProps.record &&
              controllerProps.record.enable_mobile_app && (
                <GoogleMapsLink props={props} />
              )}

            <Button style={styles.button}>
              Anonymous Reporting Status
              <Indicator
                id={props.id}
                record={controllerProps.record}
                indicator_source={"enable_anonymous_reporting"}
              />
            </Button>
            <Button style={styles.button}>
              Mutual Link Status
              <Indicator
                id={props.id}
                record={controllerProps.record}
                indicator_source={"mutualink_enabled"}
              />
            </Button>
            {/*POC*/}
            <Button
              style={styles.button}
              onClick={() => setisPOCToggleOn(!isPOCToggleOn)}
            >
              Points of Contact
            </Button>
            {isPOCToggleOn && (
              <TextField
                label="Client Point Of Contact Phone Name"
                source="client_poc_name"
              />
            )}
            {isPOCToggleOn && (
              <TextField
                label="Client Point Of Contact Phone Number"
                source="client_poc_phone"
              />
            )}
            {isPOCToggleOn && (
              <TextField
                label="Client Point Of Contact Email Address"
                source="client_poc_email"
              />
            )}
            {user.role === "super-admin" && isPOCToggleOn && (
              <TextField
                label="Dispatch Point Of Contact Phone Name"
                source="dispatch_poc_name"
              />
            )}
            {user.role === "super-admin" && isPOCToggleOn && (
              <TextField
                label="Dispatch Point Of Contact Phone Number"
                source="dispatch_poc_phone"
              />
            )}
            {user.role === "super-admin" && isPOCToggleOn && (
              <TextField
                label="Dispatch Point Of Contact Email Address"
                source="dispatch_poc_email"
              />
            )}
            {user.role === "super-admin" && isPOCToggleOn && (
              <TextField
                label="Law Enforcement Point Of Contact Name"
                source="law_enforcement_poc_name"
              />
            )}
            {user.role === "super-admin" && isPOCToggleOn && (
              <TextField
                label="Law Enforcement Point Of Contact Phone Number"
                source="law_enforcement_poc_phone"
              />
            )}
            {user.role === "super-admin" && isPOCToggleOn && (
              <TextField
                label="Law Enforcement Point Of Contact Email Address"
                source="law_enforcement_poc_email"
              />
            )}

            {user.role === "super-admin" && isPOCToggleOn && (
              <TextField
                label="Dispatch Console Alert Contact Number"
                source="alert_contact_phone_number"
              />
            )}

            {/*Consoles*/}
            <Button
              style={styles.button}
              onClick={() =>
                setisDispatchTabletToggleOn(!isDispatchTabletToggleOn)
              }
            >
              Consoles
            </Button>
            {isDispatchTabletToggleOn && (
              <OrgDTPopup
                {...props}
                onclickoutside={() => setisDispatchTabletToggleOn(false)}
              />
            )}

            {/*Zones*/}
            <Button
              style={styles.button}
              onClick={() => setisZoneToggleOn(!isZoneToggleOn)}
            >
              Zones
            </Button>
            {isZoneToggleOn && (
              <OrgZonePopup
                {...props}
                onclickoutside={() => setisZoneToggleOn(false)}
              />
            )}

            {/*Users*/}
            <Button
              style={styles.button}
              onClick={() => setisUserToggleOn(!isUserToggleOn)}
            >
              Admins
            </Button>
            {isUserToggleOn && (
              <OrgAdminsPopup
                {...props}
                onclickoutside={() => setisUserToggleOn(false)}
              />
            )}

            {/*Contact Lists*/}
            <Button
              style={styles.button}
              onClick={() => setisContactlistToggleOn(!isContactlistToggleOn)}
            >
              Contact Lists
            </Button>
            {isContactlistToggleOn && (
              <OrgContactListPopup
                {...props}
                onclickoutside={() => setisContactlistToggleOn(false)}
              />
            )}
            {/*Contacts*/}
            <Button
              style={styles.button}
              onClick={() => setisContactToggleOn(!isContactToggleOn)}
            >
              Contacts
            </Button>
            {isContactToggleOn && (
              <OrgContactPopup
                {...props}
                onclickoutside={() => setisContactToggleOn(false)}
              />
            )}

            {/*Alerts*/}
            <Button
              style={styles.button}
              onClick={() => setisAlertToggleOn(!isAlertToggleOn)}
            >
              Alert History
            </Button>
            {isAlertToggleOn && (
              <OrgEventHistoryPopup
                {...props}
                onclickoutside={() => setisAlertToggleOn(false)}
              />
            )}

            {/*Webhooks*/}
            <Button
              style={styles.button}
              onClick={() => setisWebhookToggleOn(!isWebhookToggleOn)}
            >
              Webhooks
            </Button>
            {isWebhookToggleOn && (
              <OrgWebhookPopup
                {...props}
                onclickoutside={() => setisWebhookToggleOn(false)}
              />
            )}

            {/*Webhook Events*/}
            <Button
              style={styles.button}
              onClick={() =>
                setisWebhookEventsToggleOn(!isWebhookEventsToggleOn)
              }
            >
              Webhook Events
            </Button>
            {isWebhookEventsToggleOn && (
              <OrgWebhookEventsPopup
                {...props}
                onclickoutside={() => setisWebhookEventsToggleOn(false)}
              />
            )}

            {/*Panels*/}
            <Button
              style={styles.button}
              onClick={() => setisPanelToggleOn(!isPanelToggleOn)}
            >
              Panels
            </Button>
            {isPanelToggleOn && (
              <OrgPanelPopup
                {...props}
                onclickoutside={() => setisPanelToggleOn(false)}
              />
            )}

            {/*Panel Events*/}
            <Button
              style={styles.button}
              onClick={() => setisPanelEventsToggleOn(!isPanelEventsToggleOn)}
            >
              Panel Events
            </Button>
            {isPanelEventsToggleOn && (
              <OrgPanelEventsPopup
                {...props}
                onclickoutside={() => setisPanelEventsToggleOn(false)}
              />
            )}

            {/*Pendants*/}
            <Button
              style={styles.button}
              onClick={() => setisPendantToggleOn(!isPendantToggleOn)}
            >
              Pendants
            </Button>
            {isPendantToggleOn && (
              <OrgPendantPopup
                {...props}
                onclickoutside={() => setisPendantToggleOn(false)}
              />
            )}

            {/*Cameras*/}
            <Button
              style={styles.button}
              onClick={() => setisCameraToggleOn(!isCameraToggleOn)}
            >
              Cameras
            </Button>
            {isCameraToggleOn && (
              <OrgCameraPopup
                {...props}
                onclickoutside={() => setisCameraToggleOn(false)}
              />
            )}
          </SimpleShowLayout>
        </Show>
      )}
    </ShowController>
  );
};

export default OrganizationShow;
